import { getRequest, getRequestWithBlob, postRequest } from 'api/apiUtils'
import { IS_PRODUCTION } from 'utils/helperConfig'
import { downloadFileInBrowser } from 'utils/files'
import { makeQueryParamsString } from 'utils/stringHelpers'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import * as acquiringAction from './acquiring-actions'
import AcquiringActionTypes from './acquiring-types'

function* startGetDefaultCardAcquiring() {
    try {
        const { data } = yield getRequest('/merchant/payment-gateway/merchants')
        yield put(acquiringAction.successGetDefaultCardAcquiring(data))
    } catch (err) {
        yield put(acquiringAction.failureGetDefaultCardAcquiring({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log(err?.response?.data)
        }
    }
}

export function* onGetDefaultCardAcquiring() {
    yield takeLatest(AcquiringActionTypes.START_GET_DEFAULT_CARD_ACQUIRING, startGetDefaultCardAcquiring)
}

function* startPaymentGatewayMerchants({ payload: paymentGatewayQuestionnaire, bankAccountId, verificationCode }) {
    try {
        const { data } = yield postRequest(
            '/merchant/payment-gateway/merchants',
            paymentGatewayQuestionnaire,
            bankAccountId,
            verificationCode
        )
        yield put(acquiringAction.successPaymentGatewayMerchants(data))
    } catch (err) {
        yield put(acquiringAction.failurePaymentGatewayMerchants({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log('failurePaymentGatewayMerchants', err?.response?.data?.errors)
        }
    }
}

export function* onStartPaymentGatewayMerchants() {
    yield takeLatest(AcquiringActionTypes.START_PAYMENT_GATEWAY_MERCHANTS, startPaymentGatewayMerchants)
}

function* startGetAccountsAcquiring() {
    try {
        const { data } = yield getRequest('/merchant/payment-gateway/accounts')
        yield put(acquiringAction.successGetAccountsAcquiring(data))
    } catch (err) {
        yield put(acquiringAction.failureGetAccountsAcquiring({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log(err?.response?.data)
        }
    }
}

export function* onGetAccountsAcquiring() {
    yield takeLatest(AcquiringActionTypes.START_GET_ACCOUNTS_ACQUIRING, startGetAccountsAcquiring)
}

function* startAcquiringTransfersDownload({ payload: { from, to, type } }) {
    try {
        const queryParams = makeQueryParamsString({ From: from, To: to })
        const data = yield getRequestWithBlob(`/merchant/payment-gateway/transfers/period-summary/${type}${queryParams}`)
        yield put(acquiringAction.successAcquiringTransfersDownload(data.data))
    } catch (error) {
        yield put(acquiringAction.failureAcquiringTransfersDownload({ errorMessage: error.response.data.errors }))
    }
}

export function* onStartAcquiringTransfersDownload() {
    yield takeLatest(AcquiringActionTypes.START_ACQUIRING_TRANSFERS_DOWNLOAD, startAcquiringTransfersDownload)
}

function* startCardAcquiringMerchants() {
    try {
        const { data } = yield postRequest('/merchant/cardAcquiring/merchants')
        yield put(acquiringAction.successCardAcquiringMerchants(data))
    } catch (err) {
        yield put(acquiringAction.failureCardAcquiringMerchants({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartCardAcquiringMerchants() {
    yield takeLatest(AcquiringActionTypes.START_CARD_ACQUIRING_MERCHANTS, startCardAcquiringMerchants)
}

function* startGetCardAcquiringSettlements({ payload: values }) {
    try {
        const queryParams = makeQueryParamsString(values)
        const { data } = yield getRequest(`/merchant/payment-gateway/settlements${queryParams}`)
        yield put(acquiringAction.successGetCardAcquiringSettlements(data))
    } catch (err) {
        yield put(acquiringAction.failureGetCardAcquiringSettlements({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartGetCardAcquiringSettlements() {
    yield takeLatest(AcquiringActionTypes.START_GET_CARD_ACQUIRING_SETTLEMENTS, startGetCardAcquiringSettlements)
}

function* startAcquiringCredentialsRegenerate({ payload: { publicKey, verificationCode } }) {
    try {
        const { data } = yield postRequest('/merchant/payment-gateway/api-keys', { publicKey, verificationCode })
        yield put(acquiringAction.successAcquiringCredentialsRegenerate(data))
    } catch (err) {
        yield put(acquiringAction.failureAcquiringCredentialsRegenerate({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartAcquiringCredentialsRegenerate() {
    yield takeLatest(AcquiringActionTypes.START_ACQUIRING_CREDENTIALS_REGENERATE, startAcquiringCredentialsRegenerate)
}

function* startGetCardAcquiringCharges({ payload: values }) {
    try {
        const queryParams = makeQueryParamsString(values)
        const { data } = yield getRequest(`/merchant/payment-gateway/card-payments${queryParams}`)
        yield put(acquiringAction.successGetCardAcquiringCharges(data))
    } catch (err) {
        yield put(acquiringAction.failureGetCardAcquiringCharges({ errorMessage: err?.response?.data?.errors }))
        if (!IS_PRODUCTION) {
            console.log(err?.response?.data)
        }
    }
}

export function* onStartGetCardAcquiringCharges() {
    yield takeLatest(AcquiringActionTypes.START_GET_CARD_ACQUIRING_CHARGES, startGetCardAcquiringCharges)
}

function* startAcquiringChargesDownload({ payload: { id, from, to, status, type } }) {
    try {
        let data
        if (id) {
            data = yield getRequestWithBlob(`/merchant/payment-gateway/card-payments/${id}/${type}`)
        } else {
            const queryParams = makeQueryParamsString({
                from,
                to,
                hargeStatus: status,
            })
            data = yield getRequestWithBlob(`/merchant/payment-gateway/card-payments/${type}${queryParams}`)
        }
        yield put(acquiringAction.successAcquiringChargesDownload(data.data))
    } catch (error) {
        yield put(acquiringAction.failureAcquiringChargesDownload({ errorMessage: error.response.data.errors }))
    }
}

export function* onStartAcquiringChargesDownload() {
    yield takeLatest(AcquiringActionTypes.START_ACQUIRING_CHARGES_DOWNLOAD, startAcquiringChargesDownload)
}

function* startSettlementsPdfDownload({ payload: { from, to } }) {
    try {
        const queryParams = makeQueryParamsString({ from, to })

        const { data } = yield getRequestWithBlob(`/merchant/payment-gateway/settlements/pdf${queryParams}`)
        yield put(acquiringAction.successSettlementsPdfDownload(data))
        downloadFileInBrowser(data, 'application/pdf', `Settlements ${from}-${to}.pdf`)
    } catch (error) {
        yield put(acquiringAction.failureSettlementsPdfDownload({ errorMessage: error.response.data.errors }))
    }
}

export function* onStartSettlementsPdfDownload() {
    yield takeLatest(AcquiringActionTypes.START_SETTLEMENTS_PDF_DOWNLOAD, startSettlementsPdfDownload)
}
function* startSettlementPdfDownload({ payload: { id } }) {
    try {
        const { data } = yield getRequestWithBlob(`/merchant/payment-gateway/settlements/${id}/pdf`)
        yield put(acquiringAction.successSettlementPdfDownload(data))
        downloadFileInBrowser(data, 'application/pdf', `Settlement #${id}.pdf`)
    } catch (error) {
        yield put(acquiringAction.failureSettlementPdfDownload({ errorMessage: error.response.data.errors }))
    }
}

export function* onStartSettlementPdfDownload() {
    yield takeLatest(AcquiringActionTypes.START_SETTLEMENT_PDF_DOWNLOAD, startSettlementPdfDownload)
}

function* startSettlementsCsvDownload({ payload: { from, to } }) {
    try {
        const queryParams = makeQueryParamsString({
            from,
            to,
        })
        const { data } = yield getRequestWithBlob(`/merchant/payment-gateway/settlements/csv${queryParams}`)
        yield put(acquiringAction.successSettlementsCsvDownload(data))
        downloadFileInBrowser(data, 'text/csv', `Settlements ${from} - ${to}.csv`)
    } catch (error) {
        yield put(acquiringAction.failureSettlementsCsvDownload({ errorMessage: error.response.data.errors }))
    }
}

export function* onStartSettlementsCsvDownload() {
    yield takeLatest(AcquiringActionTypes.START_SETTLEMENTS_CSV_DOWNLOAD, startSettlementsCsvDownload)
}

function* startSettlementsPeriodSummaryDownload({ payload: { from, to } }) {
    try {
        const queryParams = makeQueryParamsString({
            from,
            to,
        })
        const { data } = yield getRequestWithBlob(`/merchant/payment-gateway/settlements/period-summary/pdf${queryParams}`)
        yield put(acquiringAction.successSettlementsPeriodSummaryDownload(data))
        downloadFileInBrowser(data, 'application/pdf', `Settlements summary ${from} - ${to}.pdf`)
    } catch (error) {
        yield put(acquiringAction.failureSettlementsPeriodSummaryDownload({ errorMessage: error.response.data.errors }))
    }
}

export function* onStartSettlementsPeriodSummaryDownload() {
    yield takeLatest(AcquiringActionTypes.START_SETTLEMENTS_PERIOD_SUMMARY_DOWNLOAD, startSettlementsPeriodSummaryDownload)
}

function* startChargesReceiptPdf({ payload: { id } }) {
    try {
        const { data } = yield getRequestWithBlob(`/merchant/payment-gateway/card-payments/${id}/receipts/pdf`)
        yield put(acquiringAction.successChargesReceiptPdf(data))
        downloadFileInBrowser(data, 'application/pdf', `Payment receipt #${id}.pdf`)
    } catch (error) {
        yield put(acquiringAction.failureSettlementsPeriodSummaryDownload({ errorMessage: error.response.data.errors }))
    }
}

export function* onStartChargesReceiptPdf() {
    yield takeLatest(AcquiringActionTypes.START_CHARGES_RECEIPT_PDF, startChargesReceiptPdf)
}

export function* acquiringSagas() {
    yield all([
        call(onGetDefaultCardAcquiring),
        call(onGetAccountsAcquiring),
        call(onStartAcquiringTransfersDownload),
        call(onStartCardAcquiringMerchants),
        call(onStartGetCardAcquiringSettlements),
        call(onStartAcquiringCredentialsRegenerate),
        call(onStartGetCardAcquiringCharges),
        call(onStartAcquiringChargesDownload),
        call(onStartSettlementsPdfDownload),
        call(onStartSettlementsCsvDownload),
        call(onStartSettlementsPeriodSummaryDownload),
        call(onStartSettlementPdfDownload),
        call(onStartChargesReceiptPdf),
        call(onStartPaymentGatewayMerchants),
    ])
}
